// components/ProfessionalHeader.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './ProfessionalHeader.css';

const ProfessionalHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isHomePage = location.pathname === '/';

  return (
    <header className={`professional-header ${scrolled ? 'scrolled' : ''} ${isHomePage ? 'home-page' : 'inner-page'}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">
              <img src="/assets/images/comtel-logo-darkmode.png" alt="Comtel Infosystems" />
            </Link>
          </div>
          
          <nav className={`main-navigation ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <ul>
              <li className={location.pathname === '/' ? 'active' : ''}>
                <Link to="/">Home</Link>
              </li>
              <li className={location.pathname === '/services' ? 'active' : ''}>
                <Link to="/services">Services</Link>
              </li>
              <li className={location.pathname === '/financial-solutions' ? 'active' : ''}>
                <Link to="/financial-solutions">Financial Solutions</Link>
              </li>
              <li className={location.pathname === '/security-services' ? 'active' : ''}>
                <Link to="/security-services">Security</Link>
              </li>
              <li className={location.pathname === '/about' ? 'active' : ''}>
                <Link to="/about">About</Link>
              </li>
              <li className={location.pathname === '/resources' ? 'active' : ''}>
                <Link to="/resources">Resources</Link>
              </li>
              <li className={location.pathname === '/contact' ? 'active' : ''}>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </nav>
          
          <div className="header-actions">
            <button 
              className={`mobile-toggle ${mobileMenuOpen ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle mobile menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ProfessionalHeader;